import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
import { SESSION_DATA, currentIp, BASE_IMG_URL } from "../../../constants";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Table from "../../../components/tables/table";
import {
  userBookSlotFieldData,
  userBookSlotTableData,
} from "../../../data/TableData";
import { PAGE_LIMITS, modulePermissions } from "../../../constants";
import BookSlotTable from "../../../components/tables/BookSlotTable";
import { GrUserExpert } from "react-icons/gr";
import { IoIosArrowBack, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import { MdOutlineNightlight, MdReviews } from "react-icons/md";
import { WiSunrise, WiSunset } from "react-icons/wi";
import { PiClockAfternoonThin } from "react-icons/pi";
import BookSlotAlert from "../../../components/user/BookSlotAlert";
import moment from "moment";
import UserQueryAlert from "../../../components/user/UserQueryAlert";
import ViewSubDomainAlert from "../../../components/dashboard/ViewSubDomainAlert";

const AddUserBookSlotMain = () => {
  const navigate = useNavigate();
  const { id, id2, id3 } = useParams();
  const modeLocation = id2.split("_");

  

  const MODULE_URI = "/user/userlisting/userbookslot";

  const { user } = useSelector((state) => state.user);
  const [currSlotData, setCurrSlotData] = useState([]);
  const [currExpIndexData, setCurrExpIndexData] = useState([]);
  const [addUpdate, setAddUpdate] = useState(false);
console.log("test user",user)
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(PAGE_LIMITS[0]);
  const [tableData, setTableData] = useState([]);
  const [slotAlertArray, setSlotAlertArray] = useState([]);
  const [expAvailSlotsData, setExpAvailSlotsData] = useState([]);
  const [userQuery, setUserSlot] = useState("");
  const [profileFlag, setProfileFlag] = useState(false);
  const [userProfileInfo, setUserProfileInfo] = useState("");
  const [alertData,setAlertData] =useState("");
  const [modalOpen,setModalOpen] =useState(false);
  // const [locationId, setLocationId] = useState("");
  // const [locationName, setLocationName] = useState("");
  // const [bookingMode, setBookingMode] = useState("");
  

  const [shiftData, errorShift, loadingShift, axiosFetchShift] = useAxios();
  const [expertData, errorExpert, loadingExpert, axiosFetchExpert] = useAxios();
  const [submitData, errorSubmit, loadingSubmit, axiosSubmit] = useAxios();
  const [expSlotData, errorSlotData, loadingSlotData, axiosExpSlotSubmit] = useAxios();
  const [userProfileData, errorUserData, loadingUserData, axiosFetchUserData] = useAxios();
  const [
    expAvailSlotsInfo,
    errorExpAvailSlots,
    loadingExpAvailSlots,
    axiosFetchExpAvailSlots,
  ] = useAxios();
  
  //////////////////////////////////////////////////////////////////////////////////////////////////////
  const GET_SHIFT_URL = "master/getShiftData";
  const SUBMIT_FORM_DATA_URL = "booking/userBookSlot";
  
  // const GET_EXP_URL = `expert/${user?.usertype == "admin" ? id2 : id}`;
  const GET_EXP_URL = `expert/${id}`;
  // const GET_EXP_AVAIL_SLOTS_URL = `expert/getExpertSlots/${
  //   user?.usertype == "admin" ? id2 : id
  // }/${id2}`;
  const GET_EXP_AVAIL_SLOTS_URL = `expert/getExpertSlots/${id}/${id2}`;
  const GET_EXP_SLOTS = "expert/getExpertAvailableSlots";

  const form = useForm({
    defaultValues: {},
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;

  const getShiftData = (url) => {
    axiosFetchShift({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
 
  const getExpData = (url) => {
    axiosFetchExpert({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
  const getExpAvailSlotData = (url) => {
    axiosFetchExpAvailSlots({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
  const getUserData = (url) => {
    axiosFetchUserData({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

  useEffect(() =>{
    if(id3 && id3 !== undefined && id3 !== null && id3 !== "undefined" && id3 !== "null") {
      getUserData(`users/getuser/${id3}`);
    }

  },[id3])
  useEffect(() => {
    if (userProfileData !== undefined && userProfileData !== null) {
      setUserProfileInfo(userProfileData);

    }else{
      setUserProfileInfo("");
    }

  }, [userProfileData]);
console.log("setUserProfileInfo",userProfileInfo)
  useEffect(() => {
    getShiftData(GET_SHIFT_URL);
    getExpData(GET_EXP_URL);
    getExpAvailSlotData(GET_EXP_AVAIL_SLOTS_URL);
  }, [GET_SHIFT_URL, GET_EXP_URL, GET_EXP_AVAIL_SLOTS_URL]);

  useEffect(() => {   
    expAvailSlotsInfo && expAvailSlotsInfo?.length > 0
      ? setExpAvailSlotsData(expAvailSlotsInfo)
      : setExpAvailSlotsData([]);
  }, [expAvailSlotsInfo]);

  

  const handleAvailSlots = async (getEvent) => {
    if( getEvent.target.value != "" && getEvent.target.value != null) {
    setCurrExpIndexData(expAvailSlotsData?.[getEvent.target.value]);


    let getExpSlotData = {
      slotDate:expAvailSlotsData?.[getEvent.target.value]?.["slotDate"],
      expertId: expAvailSlotsData?.[getEvent.target.value]?.["expertId"],
    };
   
    await axiosExpSlotSubmit({
      axiosInstance: axiosInstance,
      url: GET_EXP_SLOTS,
      method: "POST",
      requestConfig: {
        data: getExpSlotData,
      },
    });

    }else{
      setCurrSlotData([]);
      setCurrExpIndexData([]);
    }
    
  };
 



  useEffect(() => {   
      if (expSlotData !== undefined && expSlotData.length > 0) {
        setCurrSlotData(expSlotData);
    }
  }, [expSlotData]);

  const handleBooking = (
    modalOpenFlag = false,
    modalSubmitOpenFlag = false,
    getCurrSlotData = [],
    fetchCurrSlotRow = [],
    getExpertData = [],
    getShiftTime = ""
  ) => {
    setSlotAlertArray([
      modalOpenFlag,
      modalSubmitOpenFlag,
      getCurrSlotData,
      fetchCurrSlotRow,
      getExpertData,
      getShiftTime,
      user?.usertype=="user"?user:userProfileInfo?.[0],
      modeLocation[0], // 0->mode,
      modeLocation[1] || "", // 1->locationId

    ]); // 0->alertflag,
  };
  

  const handleSubmitBooking = async (getDataArr = []) => {
    const toTitleCase = (str) => {
      return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
        return match.toUpperCase();
      });
    };
    let slotDemoTime = moment().add(2, 'minutes').format('LT');
    let locBookId = modeLocation[0]==="offline"?modeLocation?.[1]:"";
console.log("getDataArr",getDataArr)
    let getFormData = {
      mode:modeLocation[0],
      locationId: locBookId ? locBookId.split("~")[0] : "",
      locationName: locBookId ? locBookId.split("~")[1] : "",
      userId: getDataArr?.[6]?._id,
      userEmail: getDataArr?.[6]?.email,
      userName: toTitleCase(getDataArr?.[6]?.username),
      userPhone: getDataArr?.[6]?.phone,
      expertId: getDataArr?.[4]?._id,
      expertEmail: getDataArr?.[4]?.email,
      expertName: toTitleCase(getDataArr?.[4]?.expertName),
      expertPhone: getDataArr?.[4]?.phone,
      shiftName:
        getDataArr?.[5] == "Afternoon Shift"
          ? "afternoonSlot"
          : getDataArr?.[5] == "Morning Shift"
          ? "morningSlot"
          : getDataArr?.[5] == "Evening Shift"
          ? "eveningSlot"
          : getDataArr?.[5] == "Night Shift"
          ? "nightSlot"
          : "",
      slotMainId: getDataArr?.[2]?._id,   // expOnOff Model reference Main _id of Model
      slotId: getDataArr?.[3]?._id,    // expOnOff Model reference slotId  _id of slot i.e morningSlot 
      expertModeId: getDataArr?.[3]?.expertModeId,    // expOnOff Model referenceexpertModelId i.e morningSlot 
      slotDate: getDataArr?.[2]?.slotDate,
      slotTime: getDataArr?.[3]?.time == "00:00"?slotDemoTime:getDataArr?.[3]?.time,
      bookingStatus: "B",
      userShiftQuery: userQuery,
    };
    console.log("getFormData",getFormData);
    await axiosSubmit({
      axiosInstance: axiosInstance,
      url: SUBMIT_FORM_DATA_URL,
      method: "POST",
      requestConfig: {
        data: getFormData,
      },
    });

    setAddUpdate(true);
  };
  const onFormSubmit = async (data) => {
    // const toTitleCase = (str) => {
    //   return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
    //     return match.toUpperCase();
    //   });
  };

  //     let formData = {
  //       companyId: selectCompanyData[0],
  //       name: toTitleCase(data.name),
  //       email: data.email,
  //       password: data.confPassword,
  //       phone: String(data.phone),
  //       contactPersonName: toTitleCase(data.contactPersonName),
  //       contactPersonPhone: String(data.contactPersonPhone),
  //       address: toTitleCase(data.address),
  //       countryId: selectedCountry[0],
  //       country: selectedCountry[1],
  //       stateId: selectedState[0],
  //       state: selectedState[1],
  //       districtId: selectedDistrict[0],
  //       district: selectedDistrict[1],
  //       city: toTitleCase(data.city),
  //       pincode: data.pincode,
  //       dataId: id ? id : "",
  //       currentIp: currentIp,
  //     };

  //     await axiosSubmitFranchisee({
  //       axiosInstance: axiosInstance,
  //       url: SUBMIT_FORM_DATA_URL,
  //       method: "POST",
  //       requestConfig: {
  //         data: formData,
  //       },
  //     });

  //     setAddUpdate(true);
  //   };
  useEffect(() => {
    if (errorSubmit) {
      toast.error(
        `Your slot could not be  "updated" 
          !!error:${errorSubmit}`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    } else if (addUpdate) {
      navigate("/mybookings?userBookSlot=success");
    }
  }, [loadingSubmit, errorSubmit]);

  function navigateToBookingSlotPage(rowIndex) {
    if (rowIndex >= 0) {
      const currItem = userBookSlotTableData[rowIndex];
      navigate(`${MODULE_URI}/bookslotmain/add/${id}}/${currItem?._id}`);
    } else {
      navigate(MODULE_URI);
    }
  }
  
  function navigateTouserReviewPage(rowIndex) {
    if (rowIndex >= 0) {
      //   const currItem = expertuserSlotTableData[rowIndex];
      //   navigate(`${MODULE_URI}/viewexpuserslotbooking/${currItem?._id}`);
    } else {
      //   navigate(MODULE_URI);
    }
  }

  useEffect(() => {
    if (
      userBookSlotTableData !== undefined &&
      userBookSlotTableData.length > 0
    ) {
      const tempData = userBookSlotTableData.map((item) => {
        return {
          _id: item._id,
          expertProfile: (
            <>
              <div className="row">
                <div className="col-md-6 text-right">{item.expertImage}</div>
                <div className="col-md-6 text-left">
                  <p>
                    <h2 className="text-blue">{item.expertName}</h2>
                  </p>{" "}
                  <br />
                  <p>
                    <span className="text-gray">Domain:</span>
                    <strong>{item.expertDomain}</strong>
                  </p>{" "}
                  <br />
                  <p>
                    <span className="text-gray">Sub-Domain:</span>
                    <strong>{item.expertSubDomain}</strong>
                  </p>{" "}
                  <br />
                  <p>
                    {" "}
                    <strong>
                      {" "}
                      {`${item.experience} years experience`}{" "}
                    </strong>{" "}
                  </p>
                  <br />
                  {/* <p>
                    {" "}
                    <MdReviews />{" "}
                    <strong className="text-secondary">
                      <FaStar />
                      <FaStar />
                      <FaStar />
                    </strong>{" "}
                  </p> */}
                   
                </div>
              </div>
            </>
          ),
        };
      });

      setTableData(tempData);
    } else {
      setTableData([]);
    }
  }, [userBookSlotTableData]);

  // const handleLocation = (e) => {
  //   // setExpAvailRespData([]);  
  //   resetField("location");
  //     const selectedMode = e.target.value;
  //     if (selectedMode === "offline") {
  //       // resetField("slotDate");
  //       setLocationFlag(true)

  //     } else if (selectedMode === "online") {
  //       setLocationFlag(false)
  //       getShiftData(GET_SHIFT_URL);
  //       getExpData(GET_EXP_URL);
  //       getExpAvailSlotData(GET_EXP_AVAIL_SLOTS_URL);
  //     } else {
  //       setLocationFlag(false)
  //     }
  //   }
  function closeModal(getCloseFlag = "false") {
    setModalOpen(getCloseFlag);
  }
  return (
    <>
                        <ViewSubDomainAlert modalOpen={modalOpen} closeModal={closeModal} alertData = {alertData} />
    
      <div className="card min-height-100">
        {user?.usertype == "user" ? (
          <>
            <Link to="/bookslot">
              <button className="btn btn-blue rounded-10">
                <IoIosArrowBack />
              </button>
            </Link>
          </>
        ) : (
          <Link to={`/user/userlisting/userbookslot/add/${id}`}>
            <button className="btn btn-blue rounded-10">
              <IoIosArrowBack />
            </button>
          </Link>
        )}

        <div
          className="text-center text-navyBlue"
          title="click to view expert profile"
        >
          <h2 className="mt-10 mb-20" title="click to view expert profile">
          Expert Name:  {expertData?.[0]?.expertName}
            {profileFlag == true ? (
              <>
                <IoIosArrowUp
                  onClick={() => {
                    setProfileFlag(!profileFlag);
                  }}
                />
              </>
            ) : (
              <IoIosArrowDown
                onClick={() => {
                  setProfileFlag(!profileFlag);
                }}
              />
            )}
          </h2>
          <div className={`row ${profileFlag === true ? "hide-text" : ""}`}>
             <div className="expert-block">
                <div class="image-and-button">
                  <img src={`${BASE_IMG_URL}${expertData?.[0]?.profileImagePath}`|| "https://picsum.photos/200/300/?blur"} alt="Expert Profile" className="profile-img" />
                </div>
                <div className="expert-text">
                  <h2 className="exp-name text-blue">{expertData?.[0]?.expertName} </h2>
                  <p className="exp-info"> <strong>Qualification: </strong>{expertData?.[0]?.degree}</p>
                  <p className="exp-info"><strong>Specialization: </strong>{expertData?.[0]?.specialization}</p>
                  <p className="exp-info"><strong>Domain: </strong>{expertData?.[0]?.domainName}</p>
                  <p className="exp-info"><strong>Sub-Domain: </strong>{
                
                <>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
 
  <button className="btn-no-pad-dash btn-no-outline-green rounded-5"title={
    expertData?.[0]?.subDomain
                ?.map(sub => sub?.subDomainName)
                .filter(name => !!name)
                .join(', ')
  }
  onClick={() => {
    const names = expertData?.[0]?.subDomain
      ?.map(sub => sub?.subDomainName)
      .filter(name => !!name)
      .join(', ');
    // alert(`Sub-Domains: ${names}` || 'No subdomains available');
    setAlertData(`Sub-Domains: ${names || "No subdomains available"}`);
    setModalOpen(true);
  }
}

  >
    View 
  </button>
</div>

              </>
              
             
                
                
                }</p>
                  <p className="exp-info"><strong>Experience: </strong>{`${expertData?.[0]?.experience} years `}</p>
                  {/* <p className="exp-info"> <MdReviews /> <strong className="text-secondary">
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  </strong>{" "}</p> */}
                  <button className="btn-sm btn-outline-navy-blue rounded-5 mt-10"  onClick={() => {
    // alert(expertData?.[0]?.about || 'No Profile Data');
    setAlertData(expertData?.[0]?.about|| 'No Profile Data');
    setModalOpen(true);
  }}>View Profile</button>
                </div>
          </div>
        </div>
        </div>
        <ToastContainer />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>

            <div className="row mt-20 mb-10 ">

            {/* <div className="col-md-3 ">
              <label htmlFor="mode" className="text-gray text-semi-bold">
                   Mode <span className="text-red">*</span>
                </label>
              <select
                  id="mode"
                  {...register("mode", {
                    required: {
                      value: true,
                      message: "Mode field is Required",
                    },
                  })}
                  type="text"
                  className="form-control"
                  placeholder="Select mode"
                  onChange={(e) => handleLocation(e)}
                >
                  <option value="">Select mode</option>
                  <option value="online">Online Mode</option>
                  <option value="offline">Offline Mode</option>
                  
                </select>
                <p className="text-red">{errors.mode?.message}</p>
              </div>
              {
                locationFlag === true?<>
                <div className="col-md-3 ">
              <label htmlFor="location" className="text-gray text-semi-bold">
                 Location <span className="text-red">*</span>
                </label>
              <select
                  id="location"
                  {...register("location", {
                    required: {
                      value: true,
                      message: "Location field is Required",
                    },
                  })}
                  type="text"
                  className="form-control"
                  placeholder="Select Location"
                  // onChange={(e) => setExpAvailRespData([])}
                >
                  <option value="">Select Location</option>
                  {locationData?.[0]?.LocationsData?.map((fetchRow, index) => (
                    <option value={`${fetchRow?._id}_${fetchRow?.locationName}`}>
                      {fetchRow?.locationName}
                    </option>
                  ))}
                </select>
                <p className="text-red">{errors.location?.message}</p>
              </div>
                </>:<></>
              } */}
              <div className="col-md-12_1   tank-col-info ">
            <h2 className="text-secondary text-center"> Book Slot</h2>

              {/* <label htmlFor="mode" className="text-gray text-semi-bold">
              Book Slot <span className="text-red">*</span>
                </label> */}
                <select
                  id="slotDate"
                  {...register("slotDate", {
                    required: {
                      value: true,
                      message: "Slot Date field is Required",
                    },
                  })}
                  type="text"
                  className="form-control mb-15"
                  onChange={(e) => handleAvailSlots(e)}
                >
                  <option value=""> Select Expert Slot Date</option>
                  {expAvailSlotsData.length > 0 &&
                    expAvailSlotsData?.map((fetchRow, index) => (

                      fetchRow?.slotDate >= moment().format("YYYY-MM-DD")?<>
                       <option value={index}>
                        {" "}
                        {`${moment(fetchRow?.slotDate).format("Do MMMM YYYY")}  `}
                      </option>
                      </>:<></>
                     
                    ))}
                </select>
                <p className="text-red">{errors.slotDate?.message}</p>
              </div>
            </div>
            <hr />
          </form>
        </FormProvider>
        <UserQueryAlert
        queryModalData = {slotAlertArray}
        queryModalFunction = {handleBooking}
        getQuery = {setUserSlot}
        />
        <BookSlotAlert
          modalData={slotAlertArray}
          modalFunc={handleBooking}
          submitBooking={handleSubmitBooking}
          getUserQuery={userQuery}
        />
      

        

        {[
          "Morning Shift",
          "Afternoon Shift",
          "Evening Shift",
          "Night Shift",
        ]?.map(
          (fetchShift, index) =>
            shiftData.length > 0 &&
            shiftData?.[0]?.ShiftData?.map((fetchRowShift, index) =>
              fetchShift == fetchRowShift?.shiftName ? (
                <>
                  <div className="row mt-20 mb-20">
                    <div className="col-md-1 text-left">
                      {/* <WiSunrise /> */}
                      {fetchRowShift?.shiftName} <br />
                      <span className="text-gray">{`(${fetchRowShift?.shiftStartTime} - ${fetchRowShift?.shiftEndTime})`}</span>
                      <br />
                      <span className="text-gray">
                        {fetchRowShift?.slotTime} mintues/slot
                      </span>
                    </div>
                    <div className="col-md-11 text-left">
                      {fetchRowShift?.shiftName == "Morning Shift" ? (
                        <>
                          {currSlotData.length > 0 &&
                            currSlotData?.[0]?.morningSlot?.map(
                              (fetchCurrSlotRow, index) =>
                                (fetchCurrSlotRow?.status == "A" && fetchCurrSlotRow?.expertModeId == currExpIndexData?.['_id']) ? (
                                  <>
                                  
                                    <button className="btn-slot p-5 btn-outline-blue-hov rounded-10 ml-5 mt-5"
                                                                        title="Click to book"

                                    onClick={() =>
                                      handleBooking(
                                        true,
                                        false,
                                        currSlotData?.[0],
                                        fetchCurrSlotRow,
                                        expertData?.[0],
                                        "Morning Shift"
                                      )
                                    }
                                    >
                                      {fetchCurrSlotRow?.time}
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )
                            )}
                        </>
                      ) : fetchRowShift?.shiftName == "Afternoon Shift" ? (
                        <>
                          {currSlotData.length > 0 &&
                            currSlotData?.[0]?.afternoonSlot?.map(
                              (fetchCurrSlotRow, index) =>
                                (fetchCurrSlotRow?.status == "A" && fetchCurrSlotRow?.expertModeId == currExpIndexData?.['_id']) ? (
                                  <>
                                    <button
                                      className="btn-slot p-5 btn-outline-blue-hov rounded-10 ml-5 mt-5"
                                      title="Click to book"

                                      onClick={() =>
                                        handleBooking(
                                          true,
                                          false,
                                          currSlotData?.[0],
                                          fetchCurrSlotRow,
                                          expertData?.[0],
                                          "Afternoon Shift"
                                        )
                                      }
                                    >
                                      {fetchCurrSlotRow?.time}
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )
                            )}
                        </>
                      ) : fetchRowShift?.shiftName == "Evening Shift" ? (
                        <>
                          {currSlotData.length > 0 &&
                            currSlotData?.[0]?.eveningSlot?.map(
                              (fetchCurrSlotRow, index) =>
                                (fetchCurrSlotRow?.status == "A" && fetchCurrSlotRow?.expertModeId == currExpIndexData?.['_id']) ? (
                                  <>
                                    <button className="btn-slot p-5 btn-outline-blue-hov rounded-10 ml-5 mt-5"
                                                                        title="Click to book"

                                     onClick={() =>
                                      handleBooking(
                                        true,
                                        false,
                                        currSlotData?.[0],
                                        fetchCurrSlotRow,
                                        expertData?.[0],
                                        "Evening Shift"
                                      )
                                    }
                                    >
                                      {fetchCurrSlotRow?.time}
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )
                            )}
                        </>
                      ) : fetchRowShift?.shiftName == "Night Shift" ? (
                        <>
                          {currSlotData.length > 0 &&
                            currSlotData?.[0]?.nightSlot?.map(
                              (fetchCurrSlotRow, index) =>
                                (fetchCurrSlotRow?.status == "A" && fetchCurrSlotRow?.expertModeId == currExpIndexData?.['_id']) ? (
                                  <>
                                    <button className="btn-slot p-5 btn-outline-blue-hov rounded-10 ml-5 mt-5"
                                    title="Click to book"
                                    onClick={() =>
                                      handleBooking(
                                        true,
                                        false,
                                        currSlotData?.[0],
                                        fetchCurrSlotRow,
                                        expertData?.[0],
                                        "Night Shift"
                                      )
                                    }
                                    >
                                      {fetchCurrSlotRow?.time}
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )
                            )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <hr />
                </>
              ) : (
                <></>
              )
            )
        )}
      </div>
    </>
  );
};

export default AddUserBookSlotMain;
